<template>
  <div :class="useClassName">
    <button
      v-if="showDeleteButton"
      type="button"
      class="btn btn-primary matrix_uploadButtonDelete"
      @click="uploadOnDelete(propsData.code)"
    >
      {{ $t("Delete") }}
    </button>
    <button
      v-if="getShowPreviewInUpload && getAttribute('previewFile')"
      type="button"
      class="btn btn-primary matrix_uploadButtonPreview"
      @click="uploadOnPreview(propsData.code)"
    >
      {{ $t("Preview") }}
    </button>
    <button
      type="button"
      class="btn btn-primary matrix_uploadButtonDownload"
      @click="uploadOnDownload(propsData.code)"
    >
      {{ $t("Download") }}
    </button>
    <button
      v-if="getAttribute('showRearrange')"
      type="button"
      class="btn btn-primary matrix_uploadButtonRearrange"
      @click="uploadOnRearrange(propsData.code)"
    >
      {{ $t("Rearrange pages") }}
    </button>
    <button
      v-if="getAttribute('pitstopReport')"
      type="button"
      class="btn btn-primary matrix_uploadButtonViewReport"
      @click="uploadOnViewReport(propsData.code)"
    >
      {{ $t("View report") }}
    </button>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useUploadsStore } from "@/stores/modules/uploads";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getShowPreviewInUpload"]),
    ...mapState(useConfigStore, ["getDisableDeleteUploadAfterConnect"]),
    ...mapState(useUploadsStore, ["getUploadForProductPart"]),
    showDeleteButton: function () {
      return !this.getDisableDeleteUploadAfterConnect;
    }
  },
  methods: {
    ...mapActions(useUploadsStore, [
      "uploadOnPreview",
      "uploadOnDownload",
      "uploadOnViewReport",
      "uploadOnRearrange",
      "uploadOnDelete"
    ]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "useClassName"]
};
</script>
